export enum ReachLevel {
	ADMIN = 3,
	BENEFICIARY = 5,
	FINANCIAL = 7,
	HEALTH = 6,
	MASTER = 2,
	OPERATOR = 4,
	REPASSE = 8,
	SUPER_USER = 1,
}
